import { Logo } from '@components/Logo';
import {
  getTenantLogoUrl,
  TenantLogoVariant,
} from '@connect-carrier/util/tenantTheme';
import { CSSObject, useTheme } from '@emotion/react';
import { FC, memo } from 'react';
import { getSelectedTenantCode } from '../../harness/customer';

interface TenantLogoProps {
  tenantCode?: string;
  altText?: string;
  variant?: TenantLogoVariant;
  color?: string;
  width?: string;
  height?: string;
  css?: CSSObject;
  testId?: string;
}

// ts-unused-exports:disable-next-line
export const TenantLogo: FC<TenantLogoProps> = memo(
  ({
    tenantCode,
    altText,
    variant = 'navbar',
    color,
    width = 'auto',
    height = '40px',
    css: customCss,
    testId,
  }) => {
    const { gray } = useTheme();
    const resolvedTenantCode = tenantCode ?? getSelectedTenantCode();
    const fallbackColor = color ?? gray[10];

    if (resolvedTenantCode) {
      const logoUrl = getTenantLogoUrl(resolvedTenantCode, 'default', variant);
      return (
        <img
          src={logoUrl}
          css={{ width, height, ...customCss }}
          data-testid={testId ?? 'tenant-logo'}
          alt={altText ?? 'Tenant logo'}
        />
      );
    }

    return (
      <Logo
        color={fallbackColor as fixMe}
        width={width}
        css={customCss}
        data-testid={testId ?? 'logo'}
      />
    );
  },
);
